/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'slots-branch-private': {
    width: 16,
    height: 16,
    viewBox: '12.014 11.014 47.986 47.986',
    data: '<path pid="0" d="M59.7 33.2l-4.3-4.1-18.7-17.8a1 1 0 00-1.4 0L16.6 29.1l-4.3 4.1a1 1 0 000 1.4c.4.4 1 .4 1.4 0l2.9-2.8V58c0 .5.4 1 1 1h36.8c.6 0 1-.5 1-1V31.9l2.9 2.8c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.5.4-1.2 0-1.5zm-14 15.6a3 3 0 01-3 3H29.3a3 3 0 01-3-3V38.7a3 3 0 013-3h.3v-4.2c0-3.5 2.9-6.4 6.4-6.4s6.4 2.9 6.4 6.4v4.2h.3a3 3 0 013 3v10.1z" _fill="inherit"/><path pid="1" d="M36 41.8c-.6 0-1 .4-1 1v1.8c0 .6.4 1 1 1s1-.4 1-1v-1.8c0-.5-.4-1-1-1zm0-14.7c-2.4 0-4.4 2-4.4 4.4v4.2h8.8v-4.2c0-2.4-2-4.4-4.4-4.4z" _fill="inherit"/>'
  }
})
